<template>
    <a-yoga-layout
        width-auto="1" height-auto="1"
        flex-direction="row"
        align-items="flex-start"
        justify-content="flex-start"

        padding="0.1"

        geometry="primitive: rounded-plane;"
        material="color: #001034"
        push-mesh-backwards="distance: 0.05"

        class="clickable"
    >

        <a-image
            src="/aframe-assets/icons/cancel-padded.png"
            width="0.1" height="0.1"
            yoga-layout-item="position: absolute; right:0.02; top:0.02"
            class="clickable"
            ui-icon
            :hide-modal="'#modal-'+infospot.id"
        />
      
<!--            <a-html autoEnable="false">-->
<!--              <div class="vr">-->
<!--                <h1>Peeter</h1>-->
<!--                <p>Verwiimp</p>-->
<!--              </div>-->
<!--            </a-html>-->

          <template v-for="block in infospot.children">
              <intro v-if="block.block_type === 'intro'" :block="block"></intro>
              <quote v-if="block.block_type === 'quote'" :block="block"></quote>
              <image-text v-if="block.block_type === 'image'" :block="block"></image-text>
              <image-alone v-if="block.block_type === 'imageAlone'" :block="block"></image-alone>
              <video-block v-if="block.block_type === 'video'" :block="block"></video-block>
          </template>

    </a-yoga-layout>
</template>

<script>
import Quote from "./infospot/Quote";
import Intro from "./infospot/Intro";
import ImageText from "./infospot/ImageText";
import VideoBlock from "./infospot/VideoBlock";
import ImageAlone from "./infospot/ImageAlone";

export default {
    name: "InfoSpotContent",
    props: ['infospot'],
    components: {Intro, Quote, ImageText, VideoBlock, ImageAlone},
}
</script>

<style scoped>

</style>